let interval = 1000;
let maxAttempts = 10;
let attempts = 0;
let intervalId = setInterval(function () {
  attempts++;
  let element = document.querySelector(".tee-preview-button");
  if (element) {
    console.log("Element found:", element);
    const preview = document.querySelectorAll(".tee-preview-button");
    preview.forEach((item) => {
      item.addEventListener("click", function () {
        const modal = document.querySelector(".tee-preview-popup");
        document.body.parentElement.appendChild(modal);
      });
    });
    clearInterval(intervalId);
  } else if (attempts >= maxAttempts) {
    console.log("Element not found within 10 seconds.");
    clearInterval(intervalId);
  }
}, interval);

// document.addEventListener("teeinblue-event-component-injected", function () {
//   const element = document.querySelectorAll(".main-product-block");
//   const insertAfterElement = document.querySelector(".tee-option--size");
//   element.forEach((item) => {
//     if (item.textContent.includes("Size Guide")) {
//       if (insertAfterElement) {
//         insertAfterElement.after(item);
//       }
//     }
//   });
// });


// const checkSizingChart = () => { 
//   var sizingChart = document.querySelector('.tib-size-chart .tib-size-chart-link');
//   var teeOptionTitle = document.querySelector('.tee-variants');
//   if(sizingChart && teeOptionTitle) { 
//     var existingClone = teeOptionTitle.querySelector('.tib-size-chart-link');
//     if(!existingClone) {
//       var sizingChartClone = sizingChart.cloneNode(true);
//       teeOptionTitle.appendChild(sizingChartClone);
//       sizingChartClone.addEventListener('click', function() { sizingChart.click() });
//     }
//   }
// }
// document.addEventListener('teeinblue-event-variant-changed', checkSizingChart);
// document.addEventListener('teeinblue-event-component-injected', () => {
//   const checkElementRendered = setInterval(() => {
//     if(document.querySelector('.tib-size-chart .tib-size-chart-link')) {
//       checkSizingChart();
//       clearInterval(checkElementRendered);
//     }
//   },1000)
//   document.querySelectorAll('.tee-available-products .tee-radio').forEach((radio) => {
//       radio.addEventListener('click', () => {
//          setTimeout(() => { checkSizingChart() },200)     
//       });
//   });
// })


document.addEventListener('teeinblue-event-component-injected', function() {
    const checkElementRendered = setInterval(() => {
      const elementToMove = document.querySelector('.tib-size-chart .tib-size-chart-link');
      const insertAfterElement = document.querySelector('#teeFormInputs');
      if(elementToMove) {
        clearInterval(checkElementRendered);
        insertAfterElement.before(elementToMove)
      }
    },1000)
});